import { BabylonBackground, Header, Wrapper, Footer, Text, PageContent} from "./components/";
import { About, 
    FastGuage, 
    Gallery, 
    Home, 
    Projects,
    SamplePage,
    StudentProfiles,
    WeatherApp,
    WordScrambler,
    Octal
} from "./pages";

import {
    BrowserRouter as Router,
    Switch,
    Route
  } from "react-router-dom";

import "./styles/index.scss";

function App()
{
    return (
        <>
        
        <Router>
            <Switch>
                <Route path="/about">
                    <PageContent>
                        <About />
                    </PageContent>
                </Route>
                <Route path="/gallery">
                    <PageContent>
                        <Gallery />
                    </PageContent>
                </Route>
                <Route path="/projects">
                    <PageContent>
                        <Projects />
                    </PageContent>
                </Route>
                <Route exact path="/">
                    <PageContent>
                        <Home />
                    </PageContent>
                </Route>

                <Route path="/sample">
                    <SamplePage />
                </Route>
                
                <Route path="/student-profiles">
                    <StudentProfiles/>
                </Route>
                <Route path="/word-scrambler">
                    <WordScrambler/>
                </Route>
                <Route path="/fastgauge">
                    <FastGuage></FastGuage>
                </Route>
                <Route path="/WeatherApp">
                    <WeatherApp></WeatherApp>
                </Route>
                <Route path="/octal">
                    <Octal></Octal>
                </Route>
            </Switch>
        </Router>

        </>
    );
}

export default App;
